// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Collapsible_wrapper__J8R8F","contentWrapper":"Collapsible_contentWrapper__aOOol"};